/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 我的积分兑换记录
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetExchangesHisParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  params: GetExchangesHisParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.ExchangesDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/integral/exchanges`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
